export default __webpack_public_path__ + "static/media/low_tom.82c0fc37.mp3";